import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { PlexEnvironment } from '@app/env';
import { IUpliftDto } from "@app/shared/models/dtos/uplifts";

@Injectable({
  providedIn: 'root'
})
export class UpliftsService {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  private baseUrl: string;

  constructor() {
    this.baseUrl = this.environment.apiUrl;
  }

  async loadData(): Promise<IUpliftDto[]> {
    let ob = await this.http.get<IUpliftDto[]>(`${this.baseUrl}uplifts`).toPromise();
    return ob;
  }

  async saveData(updates: IUpliftDto[]): Promise<void> {
    await this.http.put<IUpliftDto[]>(`${this.baseUrl}uplifts`, updates).toPromise();
  }
}